export default class ariaHelper {

	constructor() {
		
		this.config = {
			ariaContorlsEls: document.querySelectorAll( '[aria-controls]' ),
			modalSelector: '[data-modal-open]'
		};
		
		this.data = {
			ariaHistory: [],
			watchModalTabsOptions: null
		}
		
		this.ariaControlsToggle();
		this.watchAriaHistoryEl();
		this.watchModalClose();
		this.exitOnEsc();
		this.tabsOnlyInActiveModalAllowed();
		this.showTabsFocus();
		this.watchShowContentAcordeon();
		
	}
	
	getSlave( el ) {
		
		let ariaSlaveEl = el.getAttribute( 'aria-controls' );
		
		return document.getElementById( ariaSlaveEl );
	}
	
	getStatus( el ) {
		
		return JSON.parse(
			el.getAttribute( 'aria-expanded' )
		);
	}
	
	setStatus( el, mode ) {
		
		if ( !el.hasAttribute( 'data-aria-expanded-freeze' ) ) {
			el.setAttribute( 'aria-expanded', mode );
		}
		
		this.getSlave( el ).hidden = !mode;
	}
	
	watchAriaHistoryEl() {
		
		const historyEls = document.querySelectorAll( '[aria-controls]' );
		
		if ( !historyEls ) return;
		
		historyEls.forEach(
			( el, i ) => {
				el.addEventListener(
					'click',
					() => {
						this.data.ariaHistory.push( el );
					}
				)	
			}
		)
	}
	
	getPreviousHistoryEl( pos ) {
		
		if ( !pos ) pos = -1;
		
		return this.data.ariaHistory[ this.data.ariaHistory.length + pos ];
	}
	
	setPreviousHistoryElFocus() {
		
		let el = this.getPreviousHistoryEl( -2 );
			
		el.focus();				
		this.data.ariaHistory.splice( -1, 1 );
	}
	
	watchModalClose() {
		
		let els = document.querySelectorAll( '[data-modal-close]' );
		
		if ( !els ) return;
		
		els.forEach(
			( el, i ) => {
				el.addEventListener(
					'click',
					( e ) => {
						this.watchModalTabsOptions = null;
						this.setPreviousHistoryElFocus();
					}
				)
			}
		)
	}
	
	closeModal( el ) {
		
		if ( !el ) return;
		
		let	slave = el.getAttribute( 'aria-controls' ),
			elSlave = document.getElementById( slave );
			
		el.setAttribute( 'aria-expanded' , false );
		elSlave.hidden = true;
		this.watchModalTabsOptions = null;
	}
	
	exitOnEsc() {
		
		document.addEventListener(
			'keydown',
			( e ) => {
				if ( e.key == 'Escape' ) {
					let el = this.getPreviousHistoryEl();
					if ( el ) {						
						this.closeModal( el );
						this.setPreviousHistoryElFocus();
					}
				}
			}
		)
	}
	
	tabsOnlyInActiveModalAllowed() {
		
		const modalOpenerEls = document.querySelectorAll( this.config.modalSelector );
		
		if ( !modalOpenerEls ) return;
		
		modalOpenerEls.forEach(
			( el, i ) => {
				el.addEventListener(
					'click',
					() => {
						let ariaControls = el.getAttribute( 'aria-controls' ),
							ariaControlsEl = document.getElementById( ariaControls ),
							ariaControlsElFirstFocusableEl = ariaControlsEl.querySelectorAll( 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])' );
						this.watchModalTabsOptions = {
							parent: ariaControlsEl,
							focusTo: ariaControlsElFirstFocusableEl[0]
						};
						ariaControlsElFirstFocusableEl[0].focus();
					}
				)
			}
		);
		
		document.body.addEventListener(
			'focus', 
			( e ) => {
				let options = this.watchModalTabsOptions;
				if ( !options ) return;
				if ( !options.parent.hidden && !options.parent.contains( e.target ) ) {	
					e.stopPropagation();
					options.focusTo.focus();
				}
			},
			true
		);		
	}
	
	ariaControlsToggle() {
		
		if ( !this.config.ariaContorlsEls ) return;
		
		this.config.ariaContorlsEls.forEach(
			( ariaContorlsEl, i ) => {
			
				ariaContorlsEl.addEventListener(
					'click',
					() => {
						
						let elSlave = ariaContorlsEl.getAttribute( 'aria-controls' ),
							connectedAriaControlsEls = document.querySelectorAll( '[aria-controls="' + elSlave + '"]' );
						
						connectedAriaControlsEls.forEach(
							( el, i ) => {
								this.setStatus(
									el,
									!this.getStatus( el )
								)
							}
						)						
					}
				);
				
			}
		)
	}
	
	showTabsFocus() {
		
		document.addEventListener( 'keyup', ( e ) => {
			if ( e.which === 9 ) {
				document.documentElement.classList.add( 'focus-outline' );
			}
		} );
		
	}
	
	watchShowContentAcordeon() {
		
		let btnEl = document.querySelector( '.show-content' );
		
		if ( !btnEl ) return;
		
		btnEl.addEventListener( 'click', ( e ) => {
			
			let btnControlsElId = btnEl.getAttribute( 'aria-controls' ),
				btnControlsEl = document.getElementById( btnControlsElId );
				
			btnControlsEl.classList.remove( 'dn' );
			btnEl.remove();
			
		} );
		
	}	
}

new ariaHelper();